import React, { useEffect, useState } from "react";
import { Container } from "reactstrap";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import {
  CancelReservation,
  FetchReservationDetails,
} from "../../apis/Reservation";

const ReservationCancel = () => {
  const [reservation, setReservation] = useState();
  const { reservationId } = useParams();
  const [activeTab, setActiveTab] = useState("Host"); // Initialize with a default tab ID
  const [message, setMessage] = useState("");
  const [messageError, setMessageError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await FetchReservationDetails(reservationId);

        if (data) {
          console.log("testing");
          console.log("data is : ", data);
          setReservation(data.data.reservation);
        }
      } catch (error) {
        toast.error("Failed to fetch data");
        console.error(error);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleReservationCancel = async () => {
    if (!message) {
      setMessageError("Required*");
      return;
    }
    setMessageError("");
    try {
      const data = await CancelReservation(reservationId);
      if (data) {
        console.log("data is : ", data);
        toast.success("Reservation canceled successfully");
        navigate("/reservation");
      }
    } catch (error) {
      toast.error("Canceling reservation failed");
      console.error(error);
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
      <Container className="px-0 dark:bg-darkBg1 dark:text-[#c7d8eb]" fluid>
        {reservation ? (
          <div className="p-4 flex flex-col gap-6 ">
            <h2 className="dark:text-[#c7d8eb]">Cancel reservation</h2>
            <div className="w-full">
              <div className="rounded-md p-3 md:p-6 border border-[rgba(0,0,0,0.2)] dark:border-[rgba(255,255,255,0.2)]">
                <ul class="flex flex-wrap pl-0 text-sm font-medium text-center text-gray-500  dark:border-gray-700 dark:text-gray-400">
                  <li class="me-2">
                    <button
                      onClick={() => {
                        setActiveTab("Host");
                      }}
                      class={`rounded-full text-lg inline-block py-3.5 px-9 ${
                        activeTab === "Host"
                          ? " border border-[rgba(255,255,255,0.8)]"
                          : ""
                      } dark:text-[#c7d8eb]`}
                    >
                      Host
                    </button>
                  </li>
                  <li class="me-2">
                    <button
                      onClick={() => {
                        setActiveTab("Guest");
                      }}
                      class={`rounded-full text-lg inline-block py-3.5 px-9 ${
                        activeTab === "Guest"
                          ? " border border-[rgba(255,255,255,0.8)]"
                          : ""
                      } dark:text-[#c7d8eb]`}
                    >
                      Guest
                    </button>
                  </li>
                </ul>

                <div className="rounded-md p-3 md:p-4 dark:bg-darkBg2">
                  {activeTab === "Host" ? (
                    <div className="flex gap-2">
                      <div className="flex-1 flex flex-col gap-2">
                        <h4 className="font-semibold dark:text-[#c7d8eb]">
                          Host missed earnings
                        </h4>
                        {reservation.nightsPrices.map((nightPrice, index) => {
                          return (
                            <div key={index} className="">
                              <p className="text-muted-foreground">
                                ${nightPrice.price} x {nightPrice.nbrNights}{" "}
                                {nightPrice.nbrNights > 1 ? "nights" : "night"}
                              </p>
                            </div>
                          );
                        })}
                      </div>
                      <span className="flex-1 text-lg line-through text-red-500">
                        ${reservation.totalPrice}
                      </span>
                    </div>
                  ) : (
                    <div className="flex gap-2">
                      <div className="flex-1 flex flex-col gap-2">
                        <h4 className="font-semibold dark:text-[#c7d8eb]">
                          Refundable
                        </h4>
                        <p className="text-base text-muted-foreground">
                          Guest will be refunded the above cost
                        </p>
                      </div>
                      <span className="flex-1 text-lg dark:text-[#c7d8eb]">
                        ${reservation.totalPrice}
                      </span>
                    </div>
                  )}
                  <hr className="border" />
                  <div className="flex gap-2 items-center">
                    <div className="flex-1">
                      <h4 className="font-semibold dark:text-[#c7d8eb]">
                        Cancelation policy
                      </h4>
                      <p className="text-base text-muted-foreground">
                        Cancel up to 7 days prior to arrival and get a 50%
                        refund
                      </p>
                    </div>
                    <span className="flex-1 text-secondaryColor text-lg hover:underline cursor-pointer font-semibold">
                      {
                        reservation.property.cancellationPolicy?.itemName?.[
                          "en"
                        ]
                      }
                    </span>
                  </div>
                  <hr className="border" />
                  <div>
                    <h4 className="font-semibold dark:text-[#c7d8eb]">
                      Tell {activeTab === "Host" ? "guest" : "host"} why you
                      need to cancel?
                    </h4>
                    <textarea
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                      placeholder="Enter your message here"
                      className="mt-2 text-lg border rounded-md p-3 dark:bg-darkBg1 w-full lg:max-w-[600px] min-h-[150px] max-h-[300px] h-[150px] lg:h-[200px]"
                    />
                    {messageError && (
                      <p className="text-red-600 dark:text-red-400">
                        {messageError}
                      </p>
                    )}
                  </div>
                  <p className="text-muted-foreground text-lg">
                    This reservation will be canceled immediately
                  </p>
                  <button
                    onClick={handleReservationCancel}
                    className="bg-primaryColor hover:bg-primaryColorMuted w-fit px-5 rounded-md font-bold text-lg py-2"
                  >
                    Cancel reservation
                  </button>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div>Loading...</div>
        )}
      </Container>
      </div>
    </React.Fragment>
  );
};

export default ReservationCancel;
